import store from "../store";

const perLoadImg = (imglist, imgprop, callback) => {

    var images = new Array();
    // 加载图片
    for(let i = 0, len = imglist.length; i < len; i++) {
        var objImg = new Image();
        objImg.src = imglist[i];
        images[i] = objImg;
        
        // 将加载图片挂载到vue实例中，防止gc回收
        store.commit("SET_PRELOADIMGLIST", images)
        objImg.onload = function() {
            callback(Math.ceil((1 / imglist.length) * 100 ) * imgprop);
        }
        objImg.onerror= function() {
            callback(Math.ceil((1 / imglist.length) * 100) * imgprop);
        }
    }
}

const perloadVideo = (videolist, videoprop, callback) => {
    // 加载视频
    for(let i = 0, len = videolist.length; i < len; i++) {
        const req = new XMLHttpRequest();
        req.open('GET', videolist[i].url, true);
        req.responseType = 'blob';
        req.onload = function () {
            if (this.status === 200) {
                const videoBlob = this.response;
                const blobSrc = URL.createObjectURL(videoBlob); // IE10+

                // 保存视频blosrc地址
                store.commit("SET_BLOBURL", {
                    name: videolist[i].name,
                    bloburl: blobSrc
                })
                console.log(`[${videolist[i].name}] blobSrc loaded success...`);
            }
        };
        req.onerror = function () {
            // Error
            console.log("blobSrc loaded error")
            callback(Math.ceil((1 / videolist.length) * 100 * videoProp));
        };
        req.onloadend = function() {
            // 请求结束 （404 and other）
            callback(Math.ceil((1 / videolist.length) * 100 * videoprop));
        }
        req.send();
    }
}

const formatTime = (timestamp) => {
    const year = new Date(timestamp).getFullYear()
    const month = new Date(timestamp).getMonth() + 1
    const day = new Date(timestamp).getDate() >= 10 ? new Date(timestamp).getDate() : 0 + new Date(timestamp).getDate();

    return `${year}.${month}.${day}`
}

const debounce = (method, context, delay) => {       // 防抖动函数，method 回调函数， context 上下文, delay 延迟时间
    let timer
    return function() {
        clearTimeout(timer)
        timer = setTimeout(() => {
            method.apply(context, arguments)
        }, delay)
    }
}

const setVideoSize = (video, videoWrap) => {           // 调整video尺寸
    const videoDom = document.querySelector(video);

    if(!videoDom) {
        return
    }

    let w = videoDom.videoWidth
    , h = videoDom.videoHeight
    , videoRatio = (w / h).toFixed(2);

    let minW, minH;
    if(!videoWrap) {
        minW = document.documentElement.clientWidth;
        minH = document.documentElement.clientHeight;
    } else {
        minW = document.querySelector(videoWrap).offsetWidth;
        minH = document.querySelector(videoWrap).offsetHeight;
    }

    let widthRatio = minW / w
        , heightRatio = minH / h;

    let newWidth, newHeight;
    if (widthRatio > heightRatio) {
        newWidth = minW;
        newHeight = Math.ceil( newWidth / videoRatio );
    }
    else {
        newHeight = minH;
        newWidth = Math.ceil( newHeight * videoRatio );
    }
    videoDom.style.width = newWidth + 'px';
    videoDom.style.height = newHeight + 'px';
}

export default {
    perLoadImg,
    perloadVideo,
    formatTime,
    debounce,
    setVideoSize
}